import React from 'react'
import ReactModal from 'react-modal'
import NeoButton from '../NeoButton/NeoButton'
import { TERMS_CONDITIONS_KEYS, BUTTON_KEYS } from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next';

export default function TermsModal({ children, hideModal }) {
  const {t}=useTranslation()
  return (
    <ReactModal
      isOpen
      style={{
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          border: 'none',
          maxWidth: '550px',
          width: '50% !important',
          borderRadius: '20px',
          marginRight: '-50%',
          boxShadow: '0 0 10px #AAAAAA',
          transform: 'translate(-50%, -50%)',
        },
      }}>
      <div className='d-flex flex-column'>
        <h4 className='heading-style' style={{ margin: 0 }}>
         {t(TERMS_CONDITIONS_KEYS.HEADER)}
        </h4>
        <div className='row justify-content-center align-items-center'>
          <div className='col-12' style={{ padding: 0 }}>
            {children}
          </div>
        </div>

        <div className='modal-btn-style' style={{ marginTop: 0 }}>
          <NeoButton
            mode='newDesign'
            type='button'
            text={t(BUTTON_KEYS.ACCEPT)}
            onClick={() => {
              hideModal()
            }}
          />
        </div>
      </div>
    </ReactModal>
  )
}
